import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '../pages/HomePage.vue'
import SignUpPage from '../pages/SignUpPage.vue'
import Error404Page from '../pages/errors/404Page.vue'
import SuccessPage from '../pages/SuccessPage'

Vue.use(VueRouter)

const isAllowedSite = Array.isArray(window.allowedSites) && window.allowedSites.includes(window.currentSite)

let routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/:site',
    name: 'apuntate',
    component: SignUpPage
  },
  {
    path: '/:site/success',
    name: 'success',
    component: SuccessPage,
    props: true,
    beforeEnter: (to, from, next) => {
      if (
        from.name === 'apuntate' &&
        Object.keys(to.params).length > 0
      ) {
        return next()
      }

      return next(from.path)
    }
  },
  {
    path: '*',
    name: '404',
    component: Error404Page
  }
]

const router = new VueRouter({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isMatchSite = to.params.site === window.currentSite

  if (
    to.name === 'home' ||
    to.name === '404' ||
    (isAllowedSite && isMatchSite)
  ) {
    return next()
  }

  return next({ name: '404' })
})

export default router
